import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import styled from "styled-components";
import { EstiloButton, Alert, CloseButton } from "./App";
import { setDoc, collection, addDoc } from "firebase/firestore";
import { db } from "./Firebase";

const FormGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: 7px 0px 7px 0px;
  align-items: flex-end;
  label {
    font-size: small;
    font-weight: bold;
  }
  input {
    border: none;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    border-radius: 2px;
  }
  input:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
`;
const ContenedorFormBase = styled.div`
  text-align: center;
  width: 380px;
  margin: auto;
  margin-top: 2rem;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 330px;
  }
`;

const VoucherForm = ({ generarVoucher }) => {
  const [voucherNumero, setVoucherNumero] = useState(uuidv4());
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [dni, setDni] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [origen, setOrigen] = useState("");
  const [destino, setDestino] = useState("");
  const [fechaSalida, setFechaSalida] = useState("");
  const [horaSalida, setHoraSalida] = useState("");
  const [fechaRegreso, setFechaRegreso] = useState("");
  const [horaRegreso, setHoraRegreso] = useState("");
  const [observaciones, setObservaciones] = useState("");

  const [mostrarEstadia, setMostrarEstadia] = useState(false);

  const [estadia, setEstadia] = useState("");
  const [direccionEstadia, setDireccionEstadia] = useState("");
  const [contactoEstadia, setContactoEstadia] = useState("");
  const [alojamiento, setAlojamiento] = useState("");
  const [habitacion, setHabitacion] = useState("");
  const [inEstadia, setInEstadia] = useState("");
  const [outEstadia, setOutEstadia] = useState("");
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [observacionesEstadia, setObservacionesEstadia] = useState("");

  const [mostrarServicio, setMostrarServicio] = useState(false);

  const [servicio, setServicio] = useState("");
  const [direccionServicio, setDireccionServicio] = useState("");
  const [contactoServicio, setContactoServicio] = useState("");
  const [trfrIn, setTrfrIn] = useState("");
  const [trfrOut, setTrfrOut] = useState("");
  const [tipoDeServicio, setTipoDeServicio] = useState("");
  const [observacionesServicio, setObservacionesServicio] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
  };

  // Función para alternar la visibilidad
  const toggleEstadia = () => setMostrarEstadia((prevState) => !prevState);
  const toggleServicio = () => setMostrarServicio((prevState) => !prevState);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validar que los campos obligatorios no estén vacíos
    if (
      nombre.trim() === "" ||
      apellido.trim() === "" ||
      dni.trim() === "" ||
      origen.trim() === "" ||
      destino.trim() === "" ||
      fechaSalida.trim() === "" ||
      horaSalida.trim() === ""
    ) {
      // Mostrar mensaje de error o realizar alguna acción
      setShowAlert(true);
      return;
    }
    // Llamamos a la función voucherPDF con los datos ingresados
    generarVoucher({
      voucherNumero,
      nombre,
      apellido,
      dni,
      fechaNacimiento,
      origen,
      destino,
      fechaSalida,
      horaSalida,
      fechaRegreso,
      horaRegreso,
      observaciones,
      estadia,
      direccionEstadia,
      contactoEstadia,
      alojamiento,
      habitacion,
      inEstadia,
      outEstadia,
      checkIn,
      checkOut,
      observacionesEstadia,
      servicio,
      direccionServicio,
      contactoServicio,
      trfrIn,
      trfrOut,
      tipoDeServicio,
      observacionesServicio,
    });

    // Guardar los datos en Firestore
    guardarEnFirestore();
  };

  const guardarEnFirestore = async () => {
    try {
      const vouchersRef = collection(db, "vouchers");
      const docRef = await addDoc(vouchersRef, {
        // Usa addDoc para crear un nuevo documento con un ID generado automáticamente
        voucherNumero,
        nombre,
        apellido,
        dni,
        fechaNacimiento,
        origen,
        destino,
        fechaSalida,
        horaSalida,
        fechaRegreso,
        horaRegreso,
        observaciones,
        estadia,
        direccionEstadia,
        contactoEstadia,
        alojamiento,
        habitacion,
        inEstadia,
        outEstadia,
        checkIn,
        checkOut,
        observacionesEstadia,
        servicio,
        direccionServicio,
        contactoServicio,
        trfrIn,
        trfrOut,
        tipoDeServicio,
        observacionesServicio,
      });

      // Obtiene el ID del documento
      const docId = docRef.id;

      // Actualiza el documento para añadir el campo con el ID
      await setDoc(docRef, {
        docId: docId, // Añade el campo 'docId' con el ID del documento
        voucherNumero,
        nombre,
        apellido,
        dni,
        fechaNacimiento,
        origen,
        destino,
        fechaSalida,
        horaSalida,
        fechaRegreso,
        horaRegreso,
        observaciones,
        estadia,
        direccionEstadia,
        contactoEstadia,
        alojamiento,
        habitacion,
        inEstadia,
        outEstadia,
        checkIn,
        checkOut,
        observacionesEstadia,
        servicio,
        direccionServicio,
        contactoServicio,
        trfrIn,
        trfrOut,
        tipoDeServicio,
        observacionesServicio,
      });

      console.log("Datos guardados en Firestore");
      // Limpiar los campos y generar un nuevo voucherNumero
      setNombre("");
      setApellido("");
      setDni("");
      setVoucherNumero(uuidv4()); // Genera un nuevo número de voucher único con uuid
    } catch (error) {
      console.error("Error al guardar en Firestore:", error);
    }
  };

  return (
    <ContenedorFormBase>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Por favor, complete todos los campos.
        </Alert>
      )}
      <h5>Voucher</h5>
      <div>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <label htmlFor="apellido">Apellido:</label>
            <input
              style={{ width: "100px" }}
              type="text"
              id="apellido"
              name="apellido"
              value={apellido}
              onChange={(e) => setApellido(e.target.value)}
              required
            />
            <label htmlFor="nombre">Nombre/s:</label>
            <input
              style={{ width: "100px" }}
              type="text"
              id="nombre"
              name="nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="dni">DNI:</label>
            <input
              style={{ width: "100px" }}
              type="text"
              id="dni"
              name="dni"
              value={dni}
              onChange={(e) => setDni(e.target.value)}
              required
            />
            <label htmlFor="fechaNacimiento">Fecha de Nac.:</label>
            <input
              style={{ width: "100px" }}
              type="date"
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={fechaNacimiento}
              onChange={(e) => setFechaNacimiento(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="origen">Origen:</label>
            <input
              style={{ width: "120px" }}
              type="text"
              id="origen"
              name="origen"
              value={origen}
              onChange={(e) => setOrigen(e.target.value)}
              required
            />
            <label htmlFor="destino">Destino:</label>
            <input
              style={{ width: "120px" }}
              type="text"
              id="destino"
              name="destino"
              value={destino}
              onChange={(e) => setDestino(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="fechaSalida">Salida:</label>
            <input
              style={{ width: "120px" }}
              type="date"
              id="fechaSalida"
              name="fechaSalida"
              value={fechaSalida}
              onChange={(e) => setFechaSalida(e.target.value)}
              required
            />
            <label htmlFor="horaSalida">Hora:</label>
            <input
              style={{ width: "100px" }}
              type="time"
              id="horaSalida"
              name="horaSalida"
              value={horaSalida}
              onChange={(e) => setHoraSalida(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="fechaRegreso">Regreso:</label>
            <input
              type="date"
              id="fechaRegreso"
              name="fechaRegreso"
              value={fechaRegreso}
              onChange={(e) => setFechaRegreso(e.target.value)}
            />
            <label htmlFor="horaRegreso">Hora:</label>
            <input
              style={{ width: "100px" }}
              type="time"
              id="horaRegreso"
              name="horaRegreso"
              value={horaRegreso}
              onChange={(e) => setHoraRegreso(e.target.value)}
            />
          </FormGroup>
          <h6>Observaciones:</h6>
          <FormGroup>
            <textarea
              id="observaciones"
              name="observaciones"
              value={observaciones}
              onChange={(e) => setObservaciones(e.target.value)}
              rows="3"
              style={{ width: "100%" }}
            />
          </FormGroup>

          <FormGroup>
            <input
              type="checkbox"
              checked={mostrarEstadia}
              onChange={toggleEstadia}
              style={{ margin: "auto 0px auto 0px" }}
            />
            <label>Deseo completar la información de estadía.</label>
          </FormGroup>

          {mostrarEstadia && (
            <>
              <h5>Info para Estadía</h5>
              <FormGroup>
                <label htmlFor="estadia">Estadía:</label>
                <input
                  placeholder="hotel /hostel /cabaña"
                  type="text"
                  id="estadia"
                  name="estadia"
                  value={estadia}
                  onChange={(e) => setEstadia(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="direccionEstadia">Dirección:</label>
                <input
                  type="text"
                  id="direccionEstadia"
                  name="direccionEstadia"
                  value={direccionEstadia}
                  onChange={(e) => setDireccionEstadia(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="contactoEstadia">Teléfono:</label>
                <input
                  type="text"
                  id="contactoEstadia"
                  name="contactoEstadia"
                  value={contactoEstadia}
                  onChange={(e) => setContactoEstadia(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="alojamiento">Alojamiento:</label>
                <input
                  placeholder="cantidad de noches"
                  type="text"
                  id="alojamiento"
                  name="alojamiento"
                  value={alojamiento}
                  onChange={(e) => setAlojamiento(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="habitacion">Habitación:</label>
                <input
                  placeholder="tipo"
                  type="text"
                  id="habitacion"
                  name="habitacion"
                  value={habitacion}
                  onChange={(e) => setHabitacion(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="inEstadia">In:</label>
                <input
                  style={{ width: "120px" }}
                  type="date"
                  id="inEstadia"
                  name="inEstadia"
                  value={inEstadia}
                  onChange={(e) => setInEstadia(e.target.value)}
                />
                <label htmlFor="outEstadia">Out:</label>
                <input
                  style={{ width: "120px" }}
                  type="date"
                  id="outEstadia"
                  name="outEstadia"
                  value={outEstadia}
                  onChange={(e) => setOutEstadia(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="checkIn">Check in:</label>
                <input
                  style={{ width: "100px" }}
                  type="time"
                  id="checkIn"
                  name="checkIn"
                  value={checkIn}
                  onChange={(e) => setCheckIn(e.target.value)}
                />
                <label htmlFor="checkOut">Check out:</label>
                <input
                  style={{ width: "100px" }}
                  type="time"
                  id="checkOut"
                  name="checkOut"
                  value={checkOut}
                  onChange={(e) => setCheckOut(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="observacionesEstadia">Observ. Estadía:</label>
                <input
                  type="text"
                  id="observacionesEstadia"
                  name="observacionesEstadia"
                  value={observacionesEstadia}
                  onChange={(e) => setObservacionesEstadia(e.target.value)}
                />
              </FormGroup>
            </>
          )}

          <FormGroup>
            <input
              type="checkbox"
              checked={mostrarServicio}
              onChange={toggleServicio}
              style={{ margin: "auto 0px auto 0px" }}
            />
            <label>Deseo completar la información de Servicio.</label>
          </FormGroup>

          {mostrarServicio && (
            <>
              <h5>Info para Servicio</h5>
              <FormGroup>
                <label htmlFor="servicio">Servicio:</label>
                <input
                  placeholder="empresa /nombre"
                  type="text"
                  id="servicio"
                  name="servicio"
                  value={servicio}
                  onChange={(e) => setServicio(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="direccionServicio">Dirección:</label>
                <input
                  type="text"
                  id="direccionServicio"
                  name="direccionServicio"
                  value={direccionServicio}
                  onChange={(e) => setDireccionServicio(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="contactoServicio">Teléfono:</label>
                <input
                  type="text"
                  id="contactoServicio"
                  name="contactoServicio"
                  value={contactoServicio}
                  onChange={(e) => setContactoServicio(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="trfrIn">Trfr In:</label>
                <input
                  placeholder="fecha /recorrido"
                  style={{ width: "120px" }}
                  type="text"
                  id="trfrIn"
                  name="trfrIn"
                  value={trfrIn}
                  onChange={(e) => setTrfrIn(e.target.value)}
                />
                <label htmlFor="trfrOut">Trfr Out:</label>
                <input
                  placeholder="fecha /recorrido"
                  style={{ width: "120px" }}
                  type="text"
                  id="trfrOut"
                  name="trfrOut"
                  value={trfrOut}
                  onChange={(e) => setTrfrOut(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="tipoDeServicio">Servicio Adicional:</label>
                <input
                  placeholder="excursión..."
                  type="text"
                  id="tipoDeServicio"
                  name="tipoDeServicio"
                  value={tipoDeServicio}
                  onChange={(e) => setTipoDeServicio(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label htmlFor="observacionesServicio">
                  Observ. del Servicio:
                </label>
                <input
                  type="text"
                  id="observacionesServicio"
                  name="observacionesServicio"
                  value={observacionesServicio}
                  onChange={(e) => setObservacionesServicio(e.target.value)}
                />
              </FormGroup>
            </>
          )}

          <EstiloButton type="submit">Generar Voucher</EstiloButton>
        </form>
      </div>
    </ContenedorFormBase>
  );
};

export default VoucherForm;
